module.exports = __webpack_public_path__ + "static/media/buy_req_help_6.e1f13467.png";